import React, { useMemo } from "react";
import {
    GiftingCartError,
    buildErrorPagePropsForErrorType,
    GIFTING_CART_ERROR_TYPE,
    useEffectOnce,
} from "@swiggy-private/core-ui";
import { closeWebview } from "@swiggy-private/checkout-core";

export const SessionExpiredError = ({
    loginHandler,
    nrEventHandler,
}: {
    loginHandler: VoidFunction;
    nrEventHandler?: (screenType: string) => void;
}) => {
    const props = useMemo(() => {
        const errorProps = buildErrorPagePropsForErrorType({
            primaryActionOnClick: loginHandler,
            secondaryActionOnClick: () => {
                closeWebview();
            },
        });
        return errorProps[GIFTING_CART_ERROR_TYPE.SESSION_EXPIRED];
    }, [loginHandler]);

    useEffectOnce(() => {
        nrEventHandler?.(GIFTING_CART_ERROR_TYPE.SESSION_EXPIRED);
    });

    return <GiftingCartError {...props} />;
};
